import styled from "styled-components";
import { theme } from "../../theme";
import { NavLink } from "react-router-dom";

export const NavContainer = styled.nav`
    display: flex;
    position: fixed;
    padding: 10px 40px;
    margin-left: 10%;
    background-color: ${theme.colors.red + "cc"};
    border-radius: 0 0 20px 20px;
    z-index: 2;
    @media (max-width: ${theme.breakpoints.mobile}) {
        margin: auto;
        border-radius: 0 0 40px 0;
        padding: 10px 30px 10px 10px;
    }
`;
//@ts-ignore
export const StyledNavLink = styled(NavLink)`
    color: ${theme.colors.white};
    margin-right: 20px;
    &:nth-last-child(1){
        margin:0;
    }
    &:hover{
        border-bottom: 1px solid white;
    }
    &.active{
        border-bottom: 1px solid white;
    }
`;